import { create } from 'zustand'

import { useMeQuery } from '@/src/features/auth/services/useMeQuery'
import { getIsLoggedIn } from '@/src/features/auth/utils/getIsLoggedIn'
import { useNotificationSettingsQuery } from '@/src/features/notification/services/useNotificationSettingsQuery'
import { ONE_WEEK_IN_MS } from '@/src/general/constants/time'

import { GENERAL_NOTIFICATION_SETTINGS } from '../../notification/models/notification.constants'
import { useWatchman } from './useWatchman'

export const useFromWatchmanEmailStore = create(() => ({ fromWatchmanEmail: false }))

export const useAskWatchman = ({ askAnonymousUsers = false }: { askAnonymousUsers?: boolean } = {}) => {
  const me = useMeQuery()
  const notification = useNotificationSettingsQuery()
  const { getHistoryRefusedBecomeWatchman } = useWatchman()
  const { fromWatchmanEmail } = useFromWatchmanEmailStore()

  const isWatchman =
    fromWatchmanEmail ||
    notification.data?.[GENERAL_NOTIFICATION_SETTINGS.ON_INTENTION_WATCHMAN].email ||
    notification.data?.[GENERAL_NOTIFICATION_SETTINGS.ON_INTENTION_WATCHMAN].push
  const { amount = 0, lastRequestDateMs = 0 } = getHistoryRefusedBecomeWatchman()
  const isPending = notification.isPending || me.isPending
  const isMyDataReady = getIsLoggedIn() && !isPending
  const isLastRequestFarEnough =
    Object.keys(getHistoryRefusedBecomeWatchman()).length === 0 ||
    (amount < 6 && Date.now() - lastRequestDateMs > ONE_WEEK_IN_MS)
  const shouldAsk = (askAnonymousUsers || isMyDataReady) && !isWatchman && isLastRequestFarEnough

  return {
    isPending: notification.isPending || me.isPending,
    isError: notification.isError,
    isWatchman,
    shouldAsk,
  }
}
